import { Component } from '@angular/core';
import { TranslationRequest } from 'src/app/shared/models/translation/translation-request';

@Component({
    selector: 'app-watch-list-page',
    template: `
    <app-section>
      <app-claim-breadcrumb></app-claim-breadcrumb>
      <app-watch-list class="tw-w-full" [translationRequest]="translationRequest"></app-watch-list>
    </app-section>
  `,
    styles: [],
    standalone: false
})
export class WatchListPageComponent {
  translationRequest = new TranslationRequest({
      language: sessionStorage.getItem('languagepreference'),
      key: null,
      contNum: 0,
      tableName: null,
      primaryKey: null,
      primaryValue: null,
      lob: null,
      group: 'WatchList',
      subGroup: 'WatchList',
    });
}
